import React, { useState, useEffect } from "react";
import {
  AccountBookOutlined,
  DashboardOutlined,
  HomeOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  NotificationFilled,
  SettingFilled,
  SnippetsOutlined,
  UploadOutlined
} from "@ant-design/icons";
import { App, Button, Layout, Menu, Grid, Drawer, Row, Col, Dropdown, Watermark } from "antd";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import Logo from "../assests/TFS Logo.png";
import watermark from "../assests/watermark.png"
import { getUser, logout } from '../../authService';
import UserDropdown from '../components/UserDropdown';
import ThemeSetting from "../components/ThemeSetting";
import UserNotification from "../components/UserNotification";
import CulsightPageLoader from "../components/CulsightPageLoader";
import SwitchButton from "../components/SwitchButton";

const { Header, Sider, Content } = Layout;
const { useBreakpoint } = Grid;

const MasterTemplate = () => {
  const { modal } = App.useApp();
  const [user, setUser] = useState(null);
  const [master_loder, set_master_loder] = useState(true);
  const [collapsed, setCollapsed] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [openKeys, setOpenKeys] = useState([]);
  // const [balck_theme, set_balck_theme] = useState(true);

  // responsive hook
  const screens = useBreakpoint();
  const isMobile = !screens.md;

  useEffect(() => {
    const localUser = localStorage.getItem("user");
    if (localUser) {
      setUser(JSON.parse(localUser));
      set_master_loder(false);
    } else {
      getUser().then(usr => {
        setUser(usr);
        set_master_loder(false);
        localStorage.setItem("user", JSON.stringify(usr));
      });
    }
  }, []);

  useEffect(() => {
    const pathToKey = {
      "/": { selected: "2" },
      "/courses": { selected: "2", open: "2" },
      "/view-course": { selected: "2", open: "2" },
      "/packages": { selected: "3", open: "3" },
      "/all-packages": { selected: "4", open: "4" },
      "/account": { selected: "7", open: "7" },
      "/list-live-test": { selected: "8", open: "8" },
      "/announcements": { selected: "9", open: "9" },
      "/view-announcements": { selected: "9", open: "9" },
    };

    const path = location.pathname;
    const match = pathToKey[path];
    if (match) {
      setSelectedKeys([match.selected]);
      if (match.open) {
        setOpenKeys([match.open]);
      } else {
        setOpenKeys([]);
      }
    }

    // const local_theme = localStorage.getItem("dark_theme");
    // local_theme === 'dark' ? set_balck_theme(1) : set_balck_theme(0);
  }, [location.pathname]);

  const handleMenuClick = ({ key }) => {
    const keyToPath = {
      1: "/",
      2: "courses",
      3: "packages",
      4: "all-packages",
      7: "/account",
      8: "/list-live-test",
      9: "/announcements",
    };

    const route = keyToPath[key];

    if (key === "50") {
      modal.confirm({
        title: "Are you sure you want to logout?",
        okText: "Logout",
        cancelText: "Cancel",
        onOk: () => {
          logout();
        },
      });
    } else if (route) {
      navigate(route);
      if (isMobile) setCollapsed(true); // mobile par navigate hone ke baad menu close
    }
  };

  const onOpenChange = (keys) => {
    setOpenKeys(keys);
  };

  const menuItems = [
    {
      key: "2",
      icon: <HomeOutlined />,
      label: "My Courses",
    },
    // {
    //   key: "2",
    //   icon: <DashboardOutlined />,
    //   label: "My Courses",
    // },
    {
      key: "3",
      icon: <AccountBookOutlined />,
      label: "My Modules",
    },
    // {
    //   key: "4",
    //   icon: <AccountBookOutlined />,
    //   label: "All Packages",
    // },
    // {
    //   key: "8",
    //   icon: <SnippetsOutlined />,
    //   label: "Live Test",
    // },
    // {
    //   key: "7",
    //   icon: <SettingFilled />,
    //   label: "Account",
    // },
    // {
    //   key: "9",
    //   icon: <NotificationFilled />,
    //   label: "Announcements",
    // },
    {
      key: "50",
      icon: <UploadOutlined />,
      label: "Logout",
    },
  ];

  return (
    <>
      {master_loder ? (
        <CulsightPageLoader />
      ) : (
        <Layout style={{ minHeight: "100vh" }}>
          {isMobile ? (
            <Drawer
              placement="left"
              open={!collapsed}
              onClose={() => setCollapsed(true)}
              bodyStyle={{ padding: 0 }}
              width={220}
              style={{
                // backgroundColor: balck_theme ? "#141414" : "#fff",
                backgroundColor: "#fff"
              }}
            >
              <div
                style={{
                  marginTop: "10px",
                  height: "60px",
                  alignItems: "center",
                  justifyContent: "center",
                  textAlign: "center",
                }}
              >
                <img
                  alt="logo"
                  src={Logo}
                  style={{
                    maxHeight: "100%",
                    width: "auto",
                    objectFit: "contain",
                    marginTop: collapsed ? "-5px" : "-5px",
                    marginLeft: collapsed ? "-12px" : "0px",
                  }}
                /><br />
                {!collapsed && (
                  <h6 style={{ marginTop: "-10px", color: "#141414", }}>
                    Travel Food Services
                  </h6>
                )}
              </div>
              <Menu
                className="gold-menu"
                mode="inline"
                selectedKeys={selectedKeys}
                openKeys={openKeys}
                onOpenChange={onOpenChange}
                onClick={handleMenuClick}
                items={menuItems}
              />
            </Drawer>
          ) : (
            <Sider
              trigger={null}
              collapsible
              collapsed={collapsed}
              onCollapse={(v) => setCollapsed(v)}
              breakpoint="md"
              collapsedWidth={isMobile ? 0 : 80}
              // style={balck_theme ? { background: "#fff" } : { background: "#fff" }}
              style={{ background: "#fff" }}
            >
              <div
                style={{
                  marginTop: "10px",
                  height: "60px",
                  alignItems: "center",
                  justifyContent: "center",
                  textAlign: "center",
                }}
              >
                <img
                  alt="logo"
                  src={Logo}
                  style={{

                    width: "125px",
                    objectFit: "contain",
                    marginTop: collapsed ? "-5px" : "-5px",
                    marginLeft: collapsed ? "-12px" : "0px",

                  }}
                /><br />
                {!collapsed && (

                  <h6 style={{ marginTop: "-10px", color: "#141414",fontSize:"16px" }}>
                    Travel Food Services
                  </h6>
                )}
              </div>
              {/* <h6 style={{ marginTop: "-10px", color: balck_theme ? "#141414" : "#141414", fontSize: "16px" }}>
                    Travel Food Services
                  </h6> */}

              <Menu
                style={{ marginTop: "40px" }}
                className="gold-menu"
                mode="inline"
                selectedKeys={selectedKeys}
                openKeys={openKeys}
                onOpenChange={onOpenChange}
                onClick={handleMenuClick}
                items={menuItems}
              />
            </Sider>
          )}

          <Layout>
            <Header
              style={
                {
                  padding: "0 10px",
                  backgroundColor: "#fff",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }
                // balck_theme
                //   ? {
                //     padding: "0 10px",
                //     backgroundColor: "#fff",
                //     display: "flex",
                //     justifyContent: "space-between",
                //     alignItems: "center",
                //   }
                //   : {
                //     padding: "0 10px",
                //     backgroundColor: "#fff",
                //     display: "flex",
                //     justifyContent: "space-between",
                //     alignItems: "center",
                //   }
              }
            >

              <div style={{ display: "flex", alignItems: "center" }}>
                <Button
                  type="text"
                  icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                  onClick={() => setCollapsed(!collapsed)}
                  style={{
                    fontSize: "16px",
                    width: 48,
                    height: 48,
                    color: "#141414",
                  }}
                />
                {!isMobile && (
                  <div>
                    <span style={{ fontWeight: "bold", fontSize: "20px" }}>
                      Learner Panel
                    </span>
                    <SwitchButton />
                  </div>

                )}
              </div>

              <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                {/* {!isMobile && <ThemeSetting set_theme_style={set_balck_theme} />} */}
                <UserNotification />
                {!isMobile && <UserDropdown user={user} />}
                {isMobile && (
                  <Dropdown
                    placement="bottomRight"
                    trigger={["click"]}
                    dropdownRender={() => (
                      <div
                        style={{
                          padding: "12px",
                          // background: balck_theme ? "#222121ff" : "#fff",
                          background: "#fff",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                          borderRadius: 8,
                          width: 220,
                        }}
                      >
                        <Row gutter={[12, 12]} justify="center">
                          <Col span={24}>
                            {/* <ThemeSetting set_theme_style={set_balck_theme} /> */}
                          </Col>
                          <Col span={24}>
                            <UserDropdown user={user} />
                          </Col>
                        </Row>
                      </div>
                    )}
                  >
                    <Button
                      type="text"
                      icon={<SettingFilled style={{ fontSize: '25px' }} />}
                      style={{
                        // color: balck_theme ? "#141414" : "#141414",
                        color:"#141414"
                      }}
                    />
                  </Dropdown>
                )}
              </div>
            </Header>

            <Content
              style={{
                backgroundColor: "#e6e6e6ff"
              }
                // balck_theme
                //   ? { backgroundColor: "#000000" }
                //   : { backgroundColor: "#e6e6e6ff" }
              }
            >

              {/* <Watermark
                image={watermark}
                rotate={0}
                width={150}
                height={150}         // center image seedha chahiye to 0
                gap={[200, 200]}    // 👈 huge gap = no repeat
                offset={[0, 0]}


              > */}

              <Outlet context={{ user, setUser }} />

              {/* </Watermark> */}


            </Content>
          </Layout>
        </Layout>
      )}
    </>
  );
};

export default MasterTemplate;
